import CommonError from '@/common/utils/errors/CommonError';
import getTaskResultErrorMessage from '@/common/utils/getTaskResultErrorMessage';

export default class TaskError extends CommonError {
  task: TaskObject;
  constructor(task: TaskObject) {
    super();
    this.name = 'Task error';

    this.task = task;

    this.message = getTaskResultErrorMessage(task) || 'Task failed due to unknown reason';
  }
}
